<app-new-private-person #privatePerson [requiredContact]="requiredContact">
</app-new-private-person>
<div class="buttons">
  <button mat-stroked-button
          color="primary"
          (click)="cancel()">
    Anuluj
  </button>
  <button mat-raised-button
          color="primary"
          [disabled]="!privatePerson.personalInfo.valid"
          (click)="add(privatePerson.personalInfo.value)">
    Dodaj
  </button>
</div>
